"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeDevWebLogin = exports.initializeDevCCLogin = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_dom_1 = __importDefault(require("react-dom"));
const fakeLogin_initializers_1 = require("./fakeLogin.initializers");
const app_render_1 = require("../app.render");
const render = async (AppWithProviders) => {
    const entrypoint = async (domElement) => {
        react_dom_1.default.render((0, jsx_runtime_1.jsx)(AppWithProviders, {}), domElement);
    };
    await (0, app_render_1.appRender)({ entrypoint });
};
const initializeDevCCLogin = async (config, DevelopmentLogin) => {
    const { authenticator, session } = await (0, fakeLogin_initializers_1.fakeLoginDRPicasoInitializer)(config);
    const AppWithProviders = () => (0, jsx_runtime_1.jsx)(DevelopmentLogin, { DRPicasoSession: session, DRPicasoAuthenticator: authenticator });
    render(AppWithProviders);
};
exports.initializeDevCCLogin = initializeDevCCLogin;
const initializeDevWebLogin = async (config, DevelopmentLogin) => {
    const { authenticator } = await (0, fakeLogin_initializers_1.fakeLoginInitializer)(config);
    const AppWithProviders = () => (0, jsx_runtime_1.jsx)(DevelopmentLogin, { authenticator: authenticator });
    render(AppWithProviders);
};
exports.initializeDevWebLogin = initializeDevWebLogin;
//# sourceMappingURL=fakeLogin.renderizers.js.map